import { ReactNode } from 'react'
import { IntlProvider as I18IntelProvider } from 'next-intl'
import { useAppSelector } from '@/redux/core'
import { selectedLocale } from '@/redux/utils'
import en from '../../locales/en/translations.json'
import fr from '../../locales/fr/translations.json'

const messagesByLocale: Record<string, Record<string, unknown>> = {
  en,
  fr,
}

export function IntlProvider({ children }: { children: ReactNode }) {
  const locale = useAppSelector(selectedLocale)
  const messages = messagesByLocale[locale] ?? messagesByLocale.en

  return (
    <I18IntelProvider messages={messages} locale={locale} timeZone={'America/Toronto'}>
      {children}
    </I18IntelProvider>
  )
}
